export const clearSearchParams = (filters, setFilters) => {
  const filterKeys = Object.keys(filters);
  const cleanFilters = {};

  filterKeys.forEach((value) => {
    cleanFilters[value] = "";
  });
  setFilters(cleanFilters);
};
